import {Injectable} from '@angular/core';
import {WindowService} from '@services/window/window.service';

@Injectable({
  providedIn: 'root',
})
export class WindowLocationService {
  constructor(private readonly windowService: WindowService) {}

  /**
   * Encapsulates window.location.assign for redirection.
   * @param url The URL to redirect to.
   */
  redirectTo(url: string): void {
    this.windowService.window.location.assign(url);
  }

  /**
   * Directly exposes window.location.assign for redirection.
   * This is functionally identical to redirectTo if redirectTo also calls assign.
   * @param url The URL to redirect to.
   */
  assign(url: string): void {
    this.windowService.window.location.assign(url);
  }

  /**
   * Encapsulates window.location.href (read-only if needed).
   */
  getCurrentHref(): string {
    return window.location.href;
  }

  /**
   * Encapsulates window.location.hostname (read-only if needed).
   */
  getHostname(): string {
    return window.location.hostname;
  }

  /**
   * Encapsulates window.location.reload() for a full page reload if needed.
   */
  reloadPage(): void {
    this.windowService.window.location.reload();
  }
}
